import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-unavailable-banner',
  templateUrl: './service-unavailable-banner.component.html',
  styleUrls: ['./service-unavailable-banner.component.less']
})
export class ServiceUnavailableBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
